const SV_API_KEY = '4r*3pb&yCFmr8vfh$cSt*bf!h#Z%f3da';

const SV_API_BASE_URL = 'https://hhi.svasti.in/'
//const SV_API_BASE_URL = 'https://localhost:3000/'

//GuestRegistration

export {
    SV_API_BASE_URL,
    SV_API_KEY
};